const style = {
  simpleRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  simpleColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  spacedBetweenRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  label: {
    fontSize: 13,
    textAlign: 'center',
    width: '100%',
  },
  largeBoldLabel: {
    fontSize: 16,
    textAlign: 'center',
    width: '100%',
    fontWeight: 'bold',
  },
  inputLabel: {
    fontWeight: 600,
    marginBottom: 4,
  },
  inputFields: {
    textAlign: 'center',
  },
  userItem: {
    cursor: 'pointer',
    fontWeight: 600,
    paddingBottom: 5,
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 5,
    borderRadius: 4,
    marginBottom: 4,
    minHeight: 30,
  },
  roomsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    overflowX: 'auto',
    paddingBottom: 4,
    alignItems: 'flex-start',
  },
  roomCard: {
    minWidth: 270,
    maxWidth: 270,
    minHeight: 320,
    border: '1px solid #b5b8bc',
    borderRadius: 6,
    padding: 8,
    backgroundColor: '#f8f9fb',
    display: 'flex',
    flexDirection: 'column',
    transition: 'border-color 0.8s ease, box-shadow 0.8s ease',
  },
  roomCardHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  roomCardTitle: {
    fontWeight: 700,
    fontSize: 13,
  },
  roomEvaluatorList: {
    height: 260,
    overflowY: 'auto',
    border: '1px solid #d0d3d8',
    borderRadius: 4,
    padding: 6,
    backgroundColor: 'var(--rr-surface)',
  },
  addRoomButton: {
    minWidth: 130,
    height: 34,
  },
};

export default style;
